import React from 'react'
import { HistoricalPerformance } from './HistoricalPerformance';
import { PortfolioPerformance } from './PortfolioPerformance';
import { FundPerformanceChart } from '../../components';

const FundPerformance = () => {
  return (
    <div className="w-100">
      <div className="header">
        <h1 className="header-title">Fund Performance</h1>
      </div>
      <div className="row w-100 card py-4 px-0">
      <div className="tradeForm position-relative mb-2">
          <FundPerformanceChart/>
        </div>
        <div className="tradeForm position-relative my-2">
          <PortfolioPerformance/>
        </div>
        <hr className='my-4'></hr>
        <div className="tradeForm position-relative">
          <HistoricalPerformance/>
        </div>
      </div>
    </div>
  );
}

export  {FundPerformance}